import React from 'react';
import { CheckCircle2, Clock, AlertTriangle } from 'lucide-react';

export function ComplianceStatus() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <CheckCircle2 className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Status pod względem zgodności
        </h2>
      </div>
      
      <div className="space-y-6">
        <div className="bg-green-50 dark:bg-green-900/20 high-contrast:bg-black p-6 rounded-lg border-l-4 border-green-500 high-contrast:border-l-white high-contrast:border-white/40">
          <h3 className="heading-5 mb-4 text-green-700 dark:text-green-400 high-contrast:text-white">
            Zgodne
          </h3>
          <ul className="space-y-3 list-none pl-0">
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Strona posiada odpowiednią strukturę nagłówków</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Wszystkie obrazy posiadają alternatywne opisy (atrybuty alt)</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Strona jest responsywna i dostosowuje się do różnych rozmiarów ekranu</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Strona posiada tryb ciemny i tryb wysokiego kontrastu dostępne z poziomu menu</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Możliwość zmiany rozmiaru tekstu za pomocą przycisków lub skrótów klawiaturowych</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Wszystkie linki posiadają wyraźne podkreślenia i zrozumiałe etykiety</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Odpowiedni kontrast kolorystyczny między tekstem a tłem (min. 4.5:1)</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Formularze posiadają powiązane etykiety, komunikaty o błędach oraz pełną obsługę przez czytniki ekranu (NVDA, VoiceOver)</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Nawigacja za pomocą klawiatury z widocznym fokusem</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Skróty klawiaturowe dla najważniejszych funkcji</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Odpowiednia struktura ARIA dla elementów interaktywnych</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Komunikaty dla czytników ekranu przy zmianach stanu</span>
            </li>
          </ul>
        </div>

        <div className="bg-yellow-50 dark:bg-yellow-900/20 high-contrast:bg-black p-6 rounded-lg border-l-4 border-yellow-500 high-contrast:border-l-white high-contrast:border-white/40">
          <h3 className="heading-5 mb-4 text-yellow-700 dark:text-yellow-400 high-contrast:text-white">
            Częściowo zgodne
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-yellow-600 dark:text-yellow-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Niektóre starsze treści mogą nie być w pełni dostępne</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-yellow-600 dark:text-yellow-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Niektóre dokumenty PDF mogą nie być w pełni dostępne</span>
            </li>
          </ul>
        </div>

        <div className="bg-red-50 dark:bg-red-900/20 high-contrast:bg-black p-6 rounded-lg border-l-4 border-red-500 high-contrast:border-l-white high-contrast:border-white/40">
          <h3 className="heading-5 mb-4 text-red-700 dark:text-red-400 high-contrast:text-white">
            Niezgodne
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white no-margin">Niektóre treści multimedialne nie posiadają napisów</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}